import { useTranslate } from "ra-core";
import { cn } from "@/lib/utils";

import { ALL_PROJECTS, useCurrentProject } from "./useCurrentProject";

/**
 * The project the employee works in now, in the header. Lists only the
 * projects they were added to; the owner sees all of them and «Все проекты».
 * Hidden when there is nothing to choose from.
 */
export const ProjectSwitcher = ({ className }: { className?: string }) => {
  const translate = useTranslate();
  const {
    projects,
    isOwner,
    isPending,
    currentId,
    current,
    setCurrentProject,
  } = useCurrentProject();

  if (isPending || projects.length < 2 || currentId == null) return null;

  return (
    <label
      className={cn(
        "flex items-center gap-2 h-8 rounded-md border bg-card pl-2.5 pr-1 text-sm min-w-0",
        className,
      )}
    >
      <span
        className="size-2 shrink-0 rounded-full bg-muted-foreground"
        style={current?.color ? { background: current.color } : undefined}
        aria-hidden
      />
      <select
        aria-label={translate("crm.projects.switcher")}
        value={String(currentId)}
        onChange={(event) => {
          const value = event.target.value;
          const project = projects.find((p) => String(p.id) === value);
          setCurrentProject(project ? project.id : ALL_PROJECTS);
        }}
        className="h-full min-w-0 max-w-48 truncate bg-transparent pr-1 font-medium outline-none cursor-pointer"
      >
        {projects.map((project) => (
          <option key={project.id} value={String(project.id)}>
            {project.name}
          </option>
        ))}
        {isOwner ? (
          <option value={ALL_PROJECTS}>{translate("crm.projects.all")}</option>
        ) : null}
      </select>
    </label>
  );
};
